<template>
  <tr class="hover" @click="openPreview">
    <td class="row-name d-flex align-items-center">
      <div class="custom-control custom-checkbox" @click.stop>
        <input type="checkbox" :checked="isSelected" class="custom-control-input mr-1" :id="'checkDoc_' + file.id"
          @change="toggleSelection" />
        <label class="custom-control-label" :for="'checkDoc_' + file.id"></label>
      </div>
      <b>{{ file.name }}</b>
    </td>
    <td>
      <span v-if="hasCases">{{ displayCaseNames }}</span>
      <span v-else><i>No assigned case</i></span>
    </td>
    <td style="width: 10%;">{{ prettyDate(file.created_at) }}</td>
  </tr>
</template>

<script>
export default {
  props: ["file", "isSelected"],
  computed: {
    displayCaseNames() {
      if (this.file.case_name) {
        return this.file.case_name;
      } else if (this.file.cases && Array.isArray(this.file.cases)) {
        return this.file.cases.map(caseItem => caseItem.name).join(', ');
      }
      return '';
    },
    hasCases() {
      return this.file.case_name || (this.file.cases && this.file.cases.length > 0);
    },
  },
  methods: {
    openPreview() {
      this.$store.commit('changeEditedDocument', this.file)
      this.$store.commit('toggleShowLightbox', true)
    },
    prettyDate(date) {
      return moment(date, 'YYYY-MM-DDTHH:mm:SSSZZ').format('MMM D, YYYY')
    },
    truncateName(input) {
      if (input.length > 24) {
        return input.substring(0, 24) + '...'
      } else {
        return input
      }
    },
    toggleSelection() {
      this.$emit("toggle-selection", this.file?.id, !this.isSelected);
    },
  }
}
</script>

<style lang="scss">
.library-card {
  height: 250px;

  .card-preview {
    background-color: #ececec;
    height: 60%;

    .card-preview-content {
      overflow: hidden;
      height: 100%;
    }
  }

  .card-details {
    height: 40%;
  }
}

.hover {
  cursor: pointer;
}

.preview-dialog {
  z-index: 2000;
}

.delete-dialog {
  z-index: 3000;
}

.edit-name-field {
  width: 500px;
  font-size: 1.2rem;
}
</style>
